import { StarRating } from "@/components/StarRating";

interface RatingStats {
  average_rating: number;
  total_reviews: number;
}

interface ProductRatingBadgeProps {
  stats?: RatingStats | null;
}

export const ProductRatingBadge = ({ stats }: ProductRatingBadgeProps) => {
  if (!stats || stats.total_reviews === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1">
      <StarRating 
        rating={stats.average_rating} 
        readonly 
        size="sm"
        showCount
        count={stats.total_reviews}
      />
    </div>
  );
};
